/* eslint-disable array-callback-return */
import React, { useEffect, useState } from 'react'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import { array } from 'prop-types'
import styled from 'styled-components'
import ColunaDireita from '../../components/ColunaDireita'
import ColunaEsquerda from '../../components/ColunaEsquerda'
import { isArray, isImpar, isPar } from '../../utils/helpers/helpers'

const Wrapper = styled.div`
  display: flex;
  max-width: 1090px;
  text-align: left;
  width: 100%;

  @media( max-width: ${StyleGuide.mediaQuery.tablet} ) {
    flex-wrap: wrap;
  }

  .card {
    margin: 0 0 30px 0;
    position: relative;

    @media( max-width: ${StyleGuide.mediaQuery.mobile} ) {
      margin: 20px auto 0;
      padding: 20px;

      button {
        margin-bottom: 0;
      }
    }
  }

  .listPlano {
    @media( max-width: ${StyleGuide.mediaQuery.mobile} ) {
      margin-top: 20px;
    }
  }
`


const useContent = children => {
  const [ contentLeft, setContentLeft ] = useState( [] )
  const [ contentRight, setContentRight ] = useState( [] )

  const createFinalContent = ( colunaEsquerda, colunaDireita ) => {
    setContentLeft( colunaEsquerda )
    setContentRight( colunaDireita )
  }

  useEffect( () => {
    let arraysEsquerda
    let arraysDireita

    const arrays = children.filter( item => item && isArray( item ) )

    if ( arrays.length ) {
      arrays.map( item => {
        arraysEsquerda = item.filter( isImpar )
        arraysDireita = item.filter( isPar )
      } )

      const conteudoRestante = children.filter( item => !isArray( item ) && item )

      const conteudoEsquerda = conteudoRestante.filter( isImpar )
      const conteudoDireita = conteudoRestante.filter( isPar )

      if ( !conteudoDireita.length ) {
        createFinalContent( [ ...arraysEsquerda ], [ ...arraysDireita, ...conteudoEsquerda ] )
      } else {
        createFinalContent( [ ...conteudoEsquerda, ...arraysEsquerda ], [ ...arraysDireita, ...conteudoDireita ] )
      }
    } else {
      const conteudoEsquerda = children.filter( isImpar )
      const conteudoDireita = children.filter( isPar )

      createFinalContent( conteudoEsquerda, conteudoDireita )
    }
  }, [ children ] )

  return [ contentLeft, contentRight ]
}

const ConteudoWrapper = ( { children } ) => {
  const [ contentLeft, contentRight ] = useContent( children )

  return (
    StyleGuide.isMobile() ?
      <Wrapper>
        { children }
      </Wrapper> :
      <Wrapper>
        <ColunaEsquerda>
          { contentLeft }
        </ColunaEsquerda>

        <ColunaDireita>
          { contentRight }
        </ColunaDireita>
      </Wrapper>
  )
}

ConteudoWrapper.propTypes = {
  'children': array.isRequired
}

export default ConteudoWrapper
